/* eslint-disable indent */
/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable no-unused-vars */
import moment from "moment";
import React, { useState, useEffect } from "react";
import "./style.scss";
import { Table, Spin, Tag, Empty } from "antd";
import { useNavigate, useLocation } from "react-router-dom";

import {
  bookingInfoCol,
  customisezColoum,
  travelInfoColSecondPage,
  auditCol,
} from "./columns";

import API from "../../api";
import urls from "../../api/urls";
import Smcs_Loader from "../../assests/images/loader-new.gif";
import { camelCase, normalizeString } from "../../utils";

import { ShipmentDetailsUI } from "@innofulfill/hubops-shipment-tracking";
import { BagDetailsUI } from "@innofulfill/hubops-shipment-tracking";

// DATE FORMATTER
const convertDate = (isoDate) => moment.utc(isoDate).format("DD-MM-YYYY HH:mm");

function ShipmentTracker() {
  const history = useLocation();
  const navigate = useNavigate();
  const { GET_SHIPMENT_TRACKING, GET_SHIPMENT_TRACKING_V2 } = urls;

  const [loading, setLoading] = useState(false);
  const [isShipmentMcn, setIsShipmentMcn] = useState(false);
  const [tableData, setTableData] = useState({});
  const [noDataFound, setNoDataFound] = useState(false);
  const [v2Status, setV2Status] = useState("");

  // unified AWB / Bag number
  const [currentAwb, setCurrentAwb] = useState("");
  const [bagorShipmentId, setBagorShipmentId] = useState("");
  const [isParentShipment, setIsParentShipment] = useState("");

  const [navStack, setNavStack] = useState([]);
  const activeRequestRef = React.useRef(null);

  // NEW VIEW should open by default ALWAYS
  const [isNewView, setIsNewView] = useState(true);

  // Overwrite session on first load to always default NEW view
  useEffect(() => {
    setIsNewView(true);
    window.sessionStorage.setItem("shipmentTrackerIsNewView", "true");
  }, []);

  const handleViewToggle = (newView) => {
    setIsNewView(newView);
    window.sessionStorage.setItem(
      "shipmentTrackerIsNewView",
      newView ? "true" : "false"
    );
  };

  // BAG INFO
  const bagItemsStyle = { flexBasis: "190px" };

  const bagColor = {
    "#2E7FE1": "Blue",
    "#70C36E": "Green",
    "#D2DD3F": "Yellow",
    "#fff": "White",
    "#FFAB02": "Orange",
    "#9F509F": "Purple",
  };

  // API CALL
  const getShipOrBagDetails = async (awbNumber) => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    setLoading(true);
    setNoDataFound(false);
    setV2Status("");

    // Call V2 API
    /*try {
      if (activeRequestRef.current !== awbNumber) {
        activeRequestRef.current = awbNumber;
        fetch(`${GET_SHIPMENT_TRACKING_V2}${awbNumber}`)
          .then((res) => res.json())
          .then((data) => {
            if (data?.statuses?.[0]?.status) {
              setV2Status(data.statuses[0].status);
            }
          })
          .catch((err) => console.error("Tracking V2 Error:", err))
          .finally(() => {
            activeRequestRef.current = null;
          });
      }
    } catch (error) {
      console.error("Tracking V2 Error:", error);
    }*/

    let response = await API.Api(
      GET_SHIPMENT_TRACKING + "?awbNumber=" + awbNumber
    ).getWithPremiseHeader();

    setLoading(false);

    if (!response?.status) {
      setNoDataFound(true);
      return;
    }

    const res = response?.response?.data;

    if (res?.statusCode === 400) {
      setNoDataFound(true);
      return;
    }

    const isShipment = !!res?.shipmentTracking;
    const isBag = !!res?.baggingTracking;

    let detectedAwb = "";
    if (isShipment) {
      detectedAwb = res?.shipmentTracking?.bookingInfoDto?.awbNumber || awbNumber;
    } else if (isBag) {
      detectedAwb =
        res?.baggingTracking?.baggingInfo?.bag_barcode || awbNumber;
    } else {
      detectedAwb = awbNumber;
    }

    setCurrentAwb(detectedAwb);
    setBagorShipmentId(detectedAwb);

    setTableData(res);
    setIsShipmentMcn(res?.shipmentTracking?.bookingInfoDto?.mcn ?? false);
    setIsParentShipment(
      res?.shipmentTracking?.bookingInfoDto?.parentAwbNumber || ""
    );
  };

  // Detect AWB from URL or state
  useEffect(() => {
    let awb = history?.state?.awb;
    if (!awb) {
      awb = new URLSearchParams(window.location.search).get("awb");
    }

    if (awb) {
      setCurrentAwb(awb);
      setNoDataFound(false);
      getShipOrBagDetails(awb);
    }
  }, [history?.state?.awb, history?.state?.num]);

  // CLICK HANDLER
  const handleShipOrBagOnClick = (awb) => {
    if (awb) {
      const url = `/shipment-tracker?awb=${awb}`;
      window.open(url, "_blank");
    }
  };

  // CENTER MESSAGE (NO DATA)
  const NoDataMessage = () => (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        height: "80vh",
      }}
    >
      <div
        style={{
          background: "#fff",
          padding: "30px 40px",
          borderRadius: "12px",
          border: "1px solid #eee",
          textAlign: "center",
          maxWidth: "1100px",
          width: "100%",
          boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
        }}
      >
        <h2 style={{ fontWeight: "500", marginBottom: "0px", color: "#333" }}>
          Details Not Found
        </h2>

        {currentAwb ? (
          <p
            style={{
              fontSize: "16px",
              fontWeight: "500",
              color: "#222",
              marginBottom: "5px",
            }}
          >
            AWB Number: {currentAwb?.replace(/\+/g, "/")}
          </p>
        ) : null}
      </div>
    </div>
  );

  // Shipment Route
  const shipmentRoute = tableData?.shipmentTracking?.route_info;
  const shipmentRouteColoum =
    shipmentRoute?.map((_, index) => ({
      title:
        index === 0
          ? "Source Hub"
          : index === shipmentRoute.length - 1
            ? "To Hub"
            : `Transit ${index}`,
      dataIndex: `col${index}`,
      key: `col${index}`,
      width: 10,
    })) || [];

  const dataSource = [
    shipmentRoute?.reduce(
      (acc, value, index) => ({
        ...acc,
        [`col${index}`]: camelCase(value),
      }),
      { key: 1 }
    ),
  ];

  // Bag Route
  const bag = tableData?.baggingTracking?.baggingInfo;

  const bagRoute = tableData?.baggingTracking?.route_info;
  const bagRouteColoum =
    bagRoute?.map((_, index) => ({
      title:
        index === 0
          ? "Source Hub"
          : index === bagRoute.length - 1
            ? "To Hub"
            : `Transit ${index}`,
      dataIndex: `col${index}`,
      key: `col${index}`,
      width: 10,
    })) || [];

  const bagDataSource = [
    bagRoute?.reduce(
      (acc, value, index) => ({
        ...acc,
        [`col${index}`]: camelCase(value),
      }),
      { key: 1 }
    ),
  ];

  // E-way Bill Info (from Version A)
  const ewayInfoCol = [
    { title: "E-way Bill ID", dataIndex: "eway_bill_id", key: "eway_bill_id" },
    { title: "E-way Bill No", dataIndex: "ewaybill_no", key: "ewaybill_no" },
    {
      title: "Created Date/Time",
      dataIndex: "eway_bill_crt_date",
      key: "eway_bill_crt_date",
      render: (text) => <span>{text ? convertDate(text) : "----"}</span>,
    },
    {
      title: "Update Date/Time",
      dataIndex: "update_date",
      key: "update_date",
      render: (text) => <span>{text ? convertDate(text) : "----"}</span>,
    },
    {
      title: "Expiry Date/Time",
      dataIndex: "ewb_bill_exp_date",
      key: "ewb_bill_exp_date",
      render: (text) => <span>{text ? convertDate(text) : "----"}</span>,
    },
  ];

  // Child Shipments
  const renderClickableAWB = (text) => (
    <span className="span-link" onClick={() => handleShipOrBagOnClick(text)}>
      {text}
    </span>
  );

  const renderTextWithFallback = (text, formatter = (val) => val) => (
    <span>{text ? formatter(text) : "----"}</span>
  );

  const childShipmentColm = [
    {
      title: "AWB Number",
      dataIndex: "awbNumber",
      key: "awbNumber",
      render: renderClickableAWB,
    },
    {
      title: "Current Hub",
      dataIndex: "currentHub",
      key: "currentHub",
      render: (text) => renderTextWithFallback(text, camelCase),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (text) => renderTextWithFallback(text, normalizeString),
    },
  ];

  const isReturn = tableData?.shipmentTracking?.isRTO;

  // Bag Info
  const bagShipment = [
    {
      itemName: bag?.isCPBag ? "Destination CP Name" : "Destination Hub Name",
      value: bag?.isCPBag
        ? camelCase(bag?.cpName)
        : camelCase(bag?.destinationHubName),
    },
    { itemName: "Type", value: camelCase(bag?.bagType) },
    { itemName: "Color", value: bagColor[bag?.bagColourType] },
    { itemName: "Bag Weight", value: bag?.bagWeight?.toFixed(2) },
    {
      itemName: "Total Volumetric Weight",
      value: bag?.totalWeight?.toFixed(2),
    },
    { itemName: "Content Type", value: camelCase(bag?.contentType) },
    { itemName: "Product", value: camelCase(bag?.product) },
    { itemName: "Mode", value: camelCase(bag?.mode) },
  ];

  return (
    <Spin
      spinning={isNewView ? loading : false}
      indicator={<img src={Smcs_Loader} style={{ height: 100, width: 100 }} />}
    >
      <div className="consolidated-tab-cntr" style={{ minHeight: "80vh" }}>

        {/* ---------- HEADER → Swapped Tabs (New | Old) ---------- */}
        <div className="tab-switch-container">
          <div
            className={`tab-option ${isNewView ? "tab-selected" : ""}`}
            onClick={() => handleViewToggle(true)}
          >
            Old
          </div>
          <div
            className={`tab-option ${!isNewView ? "tab-selected" : "blink"}`}
            onClick={() => handleViewToggle(false)}
          >
            New
          </div>
        </div>

        {/* ---------- NEW VIEW ---------- */}
        {/* ---------- NEW VIEW ---------- */}
        {!isNewView && (
          <div className="tracker-content-container" style={{ background: "#fff", padding: "10px" }}>
            {
              currentAwb?.replace(/\+/g, "/")?.length === 11 &&
                tableData?.baggingTracking != null ? (
                <BagDetailsUI
                  endpoint={GET_SHIPMENT_TRACKING}
                  awbNumber={currentAwb?.replace(/\+/g, "/")}
                  showBackArrow={false}
                />
              ) : (
                <ShipmentDetailsUI
                  endpoint={GET_SHIPMENT_TRACKING}
                  awbNumber={currentAwb?.replace(/\+/g, "/")}
                />
              )
            }
          </div>
        )}

        {/* ---------- OLD VIEW ---------- */}
        {isNewView && (
          <div className="consolidated-manifest-cntr tracker-content-container">
            {noDataFound && <NoDataMessage />}

            {/* SHIPMENT OLD VIEW */}
            {!noDataFound && tableData?.shipmentTracking && (
              <>
                <div className="new-header">
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <span>
                      {bagorShipmentId?.replace(/\+/g, "/")}
                      {isShipmentMcn && (
                        <Tag
                          color={"#FFC107"}
                          style={{ marginLeft: 8, borderRadius: "10px" }}
                        >
                          3PL
                        </Tag>
                      )}
                      &nbsp;&nbsp;
                      {isParentShipment && (
                        <span>
                          Parent Shipment ID:{" "}
                          <span
                            className="span-link"
                            onClick={() =>
                              handleShipOrBagOnClick(isParentShipment)
                            }
                          >
                            {isParentShipment}
                          </span>
                        </span>
                      )}
                      {isReturn ?
                        <Tag
                          style={{ marginLeft: 8, borderRadius: "10px", color: "#f54", backgroundColor: "#fff", borderColor: "#f54" }}
                        >RETURN</Tag> :
                        <Tag
                          style={{ marginLeft: 8, borderRadius: "10px", color: "#007BFF", backgroundColor: "#fff", borderColor: "#007BFF" }}
                        >
                          FORWARD
                        </Tag>
                      }
                      <Tag
                        color={"#007BFF"}
                        style={{ marginLeft: 8, borderRadius: "10px" }}
                      >
                        {tableData?.shipmentTracking?.latestOperation ? normalizeString(tableData?.shipmentTracking?.latestOperation) : "----"}
                      </Tag>
                    </span>
                    <div style={{ display: "flex", gap: "20px" }}>
                      <span>
                        <Tag
                          color={"#007BFF"}
                          style={{ marginLeft: 8, borderRadius: "10px" }}
                        >
                          {tableData?.shipmentTracking?.bookingInfoDto
                            ?.shipmentType
                            ? normalizeString(
                              tableData?.shipmentTracking?.bookingInfoDto
                                ?.shipmentType
                            )
                            : "----"}
                        </Tag>
                      </span>
                      <span>
                        <Tag
                          color={"#007BFF"}
                          style={{ marginLeft: 8, borderRadius: "10px" }}
                        >
                          {tableData?.shipmentTracking?.bookingInfoDto
                            ?.travelType
                            ? normalizeString(
                              tableData?.shipmentTracking?.bookingInfoDto
                                ?.travelType
                            )
                            : "----"}
                        </Tag>
                      </span>
                    </div>
                  </div>
                </div>

                <div className="new-header ml-1">
                  <span>Booking Info</span>
                </div>
                <Table
                  columns={bookingInfoCol}
                  dataSource={[tableData?.shipmentTracking?.bookingInfoDto]}
                  pagination={false}
                  scroll={{ x: 900 }}
                />

                {shipmentRouteColoum.length !== 0 && (
                  <>
                    <div className="new-header ml-1">Shipment Route</div>
                    <Table
                      columns={shipmentRouteColoum}
                      dataSource={dataSource}
                      pagination={false}
                      scroll={{ x: 900 }}
                    />
                  </>
                )}

                {tableData?.shipmentTracking?.childInfoDto?.length > 0 && (
                  <>
                    <div className="new-header ml-1">Child Shipment Info</div>
                    <Table
                      columns={childShipmentColm}
                      dataSource={tableData?.shipmentTracking?.childInfoDto}
                      pagination={false}
                      scroll={{ x: 900 }}
                    />
                  </>
                )}

                {tableData?.shipmentTracking?.ewayInfo?.length > 0 && (
                  <>
                    <div className="new-header ml-1">E-way Bill Info</div>
                    <Table
                      columns={ewayInfoCol}
                      dataSource={tableData?.shipmentTracking?.ewayInfo}
                      pagination={false}
                      scroll={{ x: 900 }}
                    />
                  </>
                )}

                <div className="new-header ml-1">Audit Info</div>
                <Table
                  columns={auditCol}
                  dataSource={tableData?.shipmentTracking?.auditInfo}
                  pagination={false}
                  locale={{
                    emptyText: (
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="No Data found."
                        style={{ margin: 0 }}
                      />
                    ),
                  }}
                />

                <div className="new-header ml-1">Travel Info</div>
                <Table
                  columns={customisezColoum.reduce((acc, item, index) => {
                    if (index === 1) {
                      acc.push({
                        title: "Bag no",
                        dataIndex: "bagBarCode",
                        render: (text) =>
                          text ? (
                            <span
                              className="span-link"
                              onClick={() => handleShipOrBagOnClick(text)}
                            >
                              {text}
                            </span>
                          ) : (
                            "----"
                          ),
                      });
                    } else {
                      acc.push(item);
                    }
                    return acc;
                  }, [])}
                  dataSource={tableData?.shipmentTracking?.travelDtos}
                  pagination={false}
                />
              </>
            )}

            {/* BAG OLD VIEW */}
            {!noDataFound && tableData?.baggingTracking && (
              <>
                <div className="new-header ml-1">
                  Bag Number: {bagorShipmentId?.replace(/\+/g, "/")}
                </div>

                <div className="new-header ml-1">Bag Info</div>
                <div
                  className="bagInfoContainer"
                  style={{
                    display: "flex",
                    flexGrow: "inherit",
                    backgroundColor: "#EAEAEA",
                  }}
                >
                  <div
                    className="newcontainer"
                    style={{ borderRight: "1px solid #BEBDBD", width: "45%" }}
                  >
                    {bagShipment?.splice(0, 3)?.map((item, index) => (
                      <React.Fragment key={index}>
                        <div className="item">
                          <span className="label" style={bagItemsStyle}>
                            {item?.itemName}:
                          </span>
                          <span className="value">{item?.value}</span>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                  <div
                    className="newcontainer"
                    style={{ borderRight: "1px solid #BEBDBD", width: "45%" }}
                  >
                    {bagShipment?.splice(3, 6)?.map((item, index) => (
                      <React.Fragment key={index}>
                        <div className="item">
                          <span className="label" style={bagItemsStyle}>
                            {item?.itemName}:
                          </span>
                          <span className="value">{item?.value}</span>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                  <div className="newcontainer" style={{ width: "45%" }}>
                    {bagShipment?.map((item, index) => (
                      <React.Fragment key={index}>
                        <div className="item">
                          <span className="label" style={bagItemsStyle}>
                            {item?.itemName}:
                          </span>
                          <span className="value">{item?.value}</span>
                        </div>
                      </React.Fragment>
                    ))}
                  </div>
                </div>

                {bagRouteColoum.length !== 0 && (
                  <>
                    <div className="new-header ml-1">Bag Route</div>
                    <Table
                      columns={bagRouteColoum}
                      dataSource={bagDataSource}
                      pagination={false}
                      scroll={{ x: 900 }}
                    />
                  </>
                )}

                <div className="new-header ml-1">Travel Info</div>
                <Table
                  columns={travelInfoColSecondPage}
                  dataSource={tableData?.baggingTracking?.travelInfoDto}
                  pagination={false}
                />

                <div className="new-header ml-1">Shipping Details</div>
                <Table
                  columns={[
                    {
                      title: "Shipment No",
                      dataIndex: "number",
                      key: "number",
                      render: (text) => (
                        <span
                          className="span-link"
                          onClick={() => handleShipOrBagOnClick(text)}
                        >
                          {text}
                        </span>
                      ),
                    },
                  ]}
                  dataSource={tableData?.baggingTracking?.bagShipmentNo?.map(
                    (number, index) => ({
                      key: index,
                      number,
                    })
                  )}
                  pagination={false}
                />
              </>
            )}

            {/* When tableData exists but neither type */}
            {!loading &&
              !noDataFound &&
              !tableData?.shipmentTracking &&
              !tableData?.baggingTracking && <NoDataMessage />}
          </div>
        )}
      </div>
    </Spin>
  );
}

export default ShipmentTracker;
